
import * as types from "../actions/dashboardTypes.js";
import * as actions from "../actions/dashboardActions.js";
import { call, put, takeEvery } from 'redux-saga/effects';
import axiosInstance from '../../interceptor/interceptor.js'; 


//FOR FETCHING DASHBOARD
function* fetchDashboardSaga() {
    try {
      ////console.log("dashboardsaga")
        const response = yield call(axiosInstance.get, '/data/dashboard'); 
        ////console.log(response.data);
        yield put(actions.fetchDashboardSuccess(response.data));
    } catch (error) {
        yield put(actions.fetchDashboardFailure(error.message));
    }
}


export default function* watchFetchData()  {
    yield takeEvery(types.FETCH_DASHBOARD_REQUEST, fetchDashboardSaga);
}
